import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-status111",
  "use": "icon-user-status111-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-status111\">\n<g id=\"icon-user-status111_icon\">\n<path id=\"icon-user-status111_Ellipse 1171\" d=\"M4 1.06641C1.60879 2.44998 0 5.03597 0 7.99782C0 12.4172 3.58172 15.9997 8 15.9997C12.4183 15.9997 16 12.4172 16 7.99782C16 5.03597 14.3912 2.44998 12 1.06641\" stroke=\"#777777\" />\n<rect id=\"icon-user-status111_Rectangle 8038\" x=\"7.46655\" width=\"1.06667\" height=\"8.53333\" fill=\"#777777\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-status111.svg
// module id = jUlx
// module chunks = 103